import { render, staticRenderFns } from "./VenueAddress.vue?vue&type=template&id=93aa00fc&scoped=true&"
import script from "./VenueAddress.vue?vue&type=script&lang=js&"
export * from "./VenueAddress.vue?vue&type=script&lang=js&"
import style0 from "./VenueAddress.vue?vue&type=style&index=0&id=93aa00fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aa00fc",
  null
  
)

export default component.exports